export const SET_TTS_INITIALIZE_COMPLETE = "SET_TTS_INITIALIZE_COMPLETE";
export const SET_STATE_TTS_PLAY_PRV_ON_NAV = "SET_STATE_TTS_PLAY_PRV_ON_NAV";
export const SET_STATE_TTS_WAS_PLAYED = "SET_STATE_TTS_WAS_PLAYED" ;
export const SET_STATE_TTS_SHOULD_PLAY = "SET_STATE_TTS_SHOULD_PLAY" ;
export const SET_STATE_TTS_LAST_PRV_URL = "SET_STATE_TTS_LAST_PRV_URL";
export const SET_STATE_TTS_SOUND_MONITOR_TIMER = "SET_STATE_TTS_SOUND_MONITOR_TIMER";
export const SET_STATE_TTS_AUDIO_PLAY_TIMER = "SET_STATE_TTS_AUDIO_PLAY_TIMER";



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/response-handler-tts/src/actions/actionTypes.js